import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Flex,
  Heading,
  Link,
  Text,
} from "@chakra-ui/react";
import { isMobile } from "react-device-detect";

function CustomFinishPage() {
  return (
    <Flex
      flexGrow={1}
      justifyContent={"center"}
      alignItems={isMobile ? "center" : "start"}
      margin={isMobile ? "1rem" : "0rem"}
      marginBottom={isMobile ? "4rem" : "0rem"}
    >
      <Card
        boxShadow={"none"}
        bg={"#35373f"}
        justifySelf={"center"}
        height={"auto"}
        marginTop={isMobile ? "0" : "4rem"}
        width={isMobile ? "100" : "70%"}
        borderLeft={"4px"}
        borderLeftColor={"#f56565"}
        paddingBottom={"1rem"}
      >
        <CardHeader>
          <Box alignSelf="start">
            <Heading
              mt={"1rem"}
              color="#3acad3"
              textAlign={"center"}
              size={"lg"}
              fontWeight={"semibold"}
              style={{
                fontVariant: "small-caps",
              }}
            >
              Assessment Complete - Thank You
            </Heading>
          </Box>
        </CardHeader>
        <CardBody>
          <Text
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
            mb={"1rem"}
          >
            You have successfully completed this first stage of the
            ControlReady™ assessment.
          </Text>
          <Text
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
            fontWeight={"semibold"}
            mb={"0.5rem"}
          >
            What happens next?
          </Text>
          <Text
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
            mb={"1rem"}
          >
            You will receive an email within 24 hours containing a link to the
            next set of assessments. Please check your inbox - and your junk or
            spam folder.
          </Text>
          <Text
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
            mb={"1rem"}
          >
            If you have any questions in the meantime, please get in touch:{" "}
            <Link
              href="mailto:controlready@dgadvisoryglobal.com"
              color={"teal.500"}
            >
              controlready@dgadvisoryglobal.com
            </Link>
          </Text>
          <Text
            fontSize={isMobile ? "md" : "lg"}
            fontFamily={"sans-serif"}
            color="#bbbbbb"
            textAlign={"left"}
          >
            We appreciate the time you have taken and will be in touch shortly.
          </Text>
        </CardBody>
      </Card>
    </Flex>
  );
}

export default CustomFinishPage;
